/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ToldsynByMakeResult
 */
export interface ToldsynByMakeResult {
    /**
     * 
     * @type {string}
     * @memberof ToldsynByMakeResult
     */
    make?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ToldsynByMakeResult
     */
    toldsynResultsImported?: number;
    /**
     * 
     * @type {number}
     * @memberof ToldsynByMakeResult
     */
    toldsynResultsExported?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ToldsynByMakeResult
     */
    vinsImported?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ToldsynByMakeResult
     */
    vinsExported?: Array<string> | null;
}

export function ToldsynByMakeResultFromJSON(json: any): ToldsynByMakeResult {
    return ToldsynByMakeResultFromJSONTyped(json, false);
}

export function ToldsynByMakeResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToldsynByMakeResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'make': !exists(json, 'make') ? undefined : json['make'],
        'toldsynResultsImported': !exists(json, 'toldsynResultsImported') ? undefined : json['toldsynResultsImported'],
        'toldsynResultsExported': !exists(json, 'toldsynResultsExported') ? undefined : json['toldsynResultsExported'],
        'vinsImported': !exists(json, 'vinsImported') ? undefined : json['vinsImported'],
        'vinsExported': !exists(json, 'vinsExported') ? undefined : json['vinsExported'],
    };
}

export function ToldsynByMakeResultToJSON(value?: ToldsynByMakeResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'make': value.make,
        'toldsynResultsImported': value.toldsynResultsImported,
        'toldsynResultsExported': value.toldsynResultsExported,
        'vinsImported': value.vinsImported,
        'vinsExported': value.vinsExported,
    };
}


